import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '@app/@core/config';
import { Observable } from 'rxjs';
import { HomeMessage } from '@shared/models/home-message';

@Injectable({
  providedIn: 'root',
})
export class HomeMessageService {
  constructor(private httpClient: HttpClient) {}

  getHomeMessages(): Observable<{ homeMessage: HomeMessage }> {
    return this.httpClient.get<{ homeMessage: HomeMessage }>(
      `${Config.serverUrl}homeMessage`,
      {
        responseType: 'json',
      }
    );
  }
}
